import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { TAB_ITEMS } from './TabBar';
import { EmptyState } from '@/components/ui/EmptyState';

export interface SidebarProps {
  collapsed?: boolean;
  onToggle?: () => void;
}

/** 320px 侧栏（≥768px 展示；可折叠为 72px 图标栏）。 */
export function Sidebar({ collapsed = false, onToggle }: SidebarProps): JSX.Element {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const items = TAB_ITEMS.filter((i) => !i.hidden);

  const toggle = (): void => {
    setIsCollapsed((v) => !v);
    onToggle?.();
  };

  return (
    <aside
      className={clsx(
        'hidden shrink-0 flex-col border-r border-line bg-panel transition-[width] md:flex',
        isCollapsed ? 'w-[72px]' : 'w-[320px]',
      )}
    >
      <nav className="flex flex-1 flex-col gap-1 p-2">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-3 rounded-btn px-3 py-2 text-sm',
                isActive ? 'bg-accent-dim text-accent' : 'text-dim hover:bg-panel-2',
              )
            }
          >
            <span aria-hidden>{item.icon}</span>
            {isCollapsed ? null : <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <button
        type="button"
        onClick={toggle}
        className="m-2 rounded-btn bg-panel-2 px-3 py-2 text-xs text-dim hover:bg-line"
      >
        {isCollapsed ? '展开' : '折叠'}
      </button>
    </aside>
  );
}

/** 右信息面板（≥1280px 常驻；768–1279 改抽屉，T05 收尾）。 */
export function RightPanel({ title = '详情' }: { title?: string }): JSX.Element {
  return (
    <aside className="hidden w-[320px] shrink-0 border-l border-line bg-panel p-4 xl:block">
      <h2 className="mb-3 text-sm font-medium text-text">{title}</h2>
      <EmptyState title="暂无内容" description="选中会话、动态或联系人后在此展示详情" />
    </aside>
  );
}

export default Sidebar;
